import customFlagOptions from '@/constants/customFlagOptions.js';
import archiveOptions from '@/constants/archiveOptions';
angular.module('leanlaw').directive('entryFilter', ['chargeManager', 'userService', 'lists', 'codeService', function (chargeManager, userService, lists, codeService) {
  function monthString(month) {
    return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][month];
  }
  return {
    restrict: 'E',
    scope: {
      filter: '=ngModel',
      createEntry: '&?',
      shortDescriptions: '=',
      areTimesVisible: '=',
      loading: '=?'
    },
    template: require('./views/entryFilter.html'),
    controller: ['$scope', function ($scope) {
      $scope.initialized = false;
      $scope.cm = $scope.$parent.editEntry;
      $scope.approvedOptions = [{
        label: 'Approved',
        id: 'true'
      }, {
        label: 'Not Approved',
        id: 'false'
      }, {
        label: 'All',
        id: 'any'
      }];
      $scope.approved = {
        id: 'false'
      };
      $scope.archiveOptions = archiveOptions;
      $scope.filter.archived = $scope.archiveOptions[0];
      $scope.cmQuery = {
        originating: false,
        involved: true,
        reviewer: false,
        primary: false,
        scopeAccount: $scope.filter.account?.id || '',
        status: '',
        archived: false
      };
      $scope.billedOptions = lists.billedOptions;
      $scope.filter.billed = $scope.billedOptions.find(option => option.id === 'WIP');
      $scope.$watch('filter', newVal => {
        $scope.cmQuery.involved = newVal.account?.id ? true : false;
        $scope.cmQuery.scopeAccount = newVal.account?.id;
      }, true);
      $scope.$watch('filter.matter', function (newMatter) {
        if (!newMatter?.id) {
          $scope.fixedFeeList = [];
          return;
        }
        if (newMatter && newMatter.id) {
          $scope.chargesLoading = true;
          chargeManager.listForMatter(newMatter.id, {
            billed: 'any'
          }).then(charges => {
            $scope.fixedFeeList = charges.sort((a, b) => {
              a.display = a.label || a.description;
              b.display = b.label || b.description;
              return a.display.localeCompare(b.display);
            });

            // if there is only one charge, display dosen't update
            if ($scope.fixedFeeList.length === 1) {
              $scope.fixedFeeList[0].display = $scope.fixedFeeList[0].label || $scope.fixedFeeList[0].description;
            }
          }).finally(() => {
            $scope.chargesLoading = false;
          });
        }
      }, true);
      userService.me().then(me => {
        $scope.me = me;
        $scope.filter.account = $scope.me;
        $scope.customFlagOptions = customFlagOptions;
        $scope.filter.customFlag = $scope.customFlagOptions[0];
        userService.list().then(users => {
          $scope.accounts = users;
        });
        $scope.showTimekeeper = me.permissions.time.createOthers;
      }, e => {
        console.error('Could not load user:', e);
      });
      $scope.codes = {};
      codeService.activityCodes().then(activity => {
        $scope.codes.activity = activity;
      });
      codeService.taskCodes().then(task => {
        $scope.codes.task = task;
      });
      var today = new Date();
      var endOfPreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      var previousMonthString = monthString(endOfPreviousMonth.getMonth()) + ' ' + endOfPreviousMonth.getFullYear();
      var startOfThisWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
      var endOfWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + 7);
      var startOfLastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() - 7);
      $scope.periods = [{
        label: 'All Time',
        range: {
          startDate: null,
          //new Date(today.getFullYear() - 2, 0, 1),
          endDate: null
        }
      }, {
        label: 'This Month',
        range: {
          startDate: new Date(today.getFullYear(), today.getMonth(), 1),
          endDate: new Date(today.getFullYear(), today.getMonth() + 1, 0)
        }
      }, {
        label: 'This Week',
        range: {
          startDate: startOfThisWeek,
          endDate: endOfWeek
        }
      }, {
        label: 'Last Week',
        range: {
          startDate: startOfLastWeek,
          endDate: startOfThisWeek
        }
      }, {
        label: 'Today',
        range: {
          startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
          endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
        }
      }, {
        label: 'Yesterday',
        range: {
          startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
          endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1)
        }
      }, {
        label: previousMonthString + ' and earlier',
        range: {
          startDate: null,
          //new Date(today.getFullYear() - 2, 0, 1),
          endDate: endOfPreviousMonth
        }
      }, {
        label: previousMonthString,
        range: {
          startDate: new Date(endOfPreviousMonth.getFullYear(), endOfPreviousMonth.getMonth(), 1),
          endDate: endOfPreviousMonth
        }
      }, {
        label: 'This Year',
        range: {
          startDate: new Date(today.getFullYear(), 0, 1),
          endDate: new Date(today.getFullYear(), 11, 31)
        }
      }, {
        label: 'Custom Period',
        custom: true,
        range: {
          startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
          endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
        }
      }];
      $scope.changePeriod = function () {
        //
      };
      $scope.fixedFeeChange = function () {};
      $scope.$watch('filter', function (newFilter) {
        if (!newFilter) return;
        window.localStorage.setItem('entriesFilter', JSON.stringify(newFilter));
      }, true);
      $scope.filter.period = $scope.periods[1];
    }]
  };
}]);